import {
  FETCH_PRODUCT_BUNDLE_PENDING,
  FETCH_PRODUCT_BUNDLE_REJECTED,
  FETCH_PRODUCT_BUNDLE_FULFILLED,
  CLEAR_PRODUCT_BUNDLE,
} from '../constants/productBundleCampaign';

const initialState = {
  pending: false,
  campaigns: [],
  error: {},
  success: false,
};

export const productBundleCampaign = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_BUNDLE_PENDING:
      return {
        ...state,
        pending: true,
        success: false,
        campaigns: [],
        error: {},
      };

    case FETCH_PRODUCT_BUNDLE_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_PRODUCT_BUNDLE_FULFILLED:
      return {
        ...state,
        campaigns: action.response,
        pending: false,
        error: {},
        success: true,
      };

    case CLEAR_PRODUCT_BUNDLE:
      return initialState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/productBundleCampaign.js